import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { NotesListItem } from '../../types/Notes/NotesListItem';
import { CreateNoteModel } from '../../types/Notes/CreateNoteModel';
export interface ReactConfig {
  applicationInsightsConnectionString: string;
}

export const notesApi = createApi({
  reducerPath: 'notesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/portalapi/notes`,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['Notes'],
  endpoints: (builder) => ({
    getNotes: builder.query<NotesListItem[], string>({
      query: (id) => ({
        url: `?participationId=${id}`,
      }),
      providesTags: ['Notes'],
    }),
    addNote: builder.mutation<void, CreateNoteModel>({
      query: (newNote) => ({
        url: '/',
        method: 'POST',
        body: newNote,
      }),
      invalidatesTags: ['Notes'],
    }),
    updateNote: builder.mutation<
      void,
      { id: string; updatedNote: CreateNoteModel }
    >({
      query: ({ id, updatedNote }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: updatedNote,
      }),
      invalidatesTags: ['Notes'],
    }),
    deleteNote: builder.mutation<void, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notes'],
    }),
  }),
});

export const {
    useGetNotesQuery,
    useAddNoteMutation,
    useUpdateNoteMutation,
    useDeleteNoteMutation,
    useLazyGetNotesQuery,
} = notesApi;
